import { useState } from 'react'
import ActionCard from './ActionCard.jsx'
import StepHeader from './StepHeader.jsx'
import TraceTimeline from './TraceTimeline.jsx'
import styles from './AIResponseLog.module.scss'









/**
 * @param {{
 *   step: {
 *     durationMs?: number,
 *     actionName: string,
 *     arguments?: string | Record<string, unknown>,
 *     result?: string | Record<string, unknown>,
 *     status?: 'ok' | 'needs_review' | 'error',
 *     defaultExpanded?: boolean,
 *     stream?: {
 *       headerMode?: 'thinking' | 'working',
 *       expanded?: boolean,
 *       loading?: boolean,
 *       argumentsText?: string,
 *       resultText?: string,
 *     },
 *   },
 *   isLast?: boolean,
 * }} props
 */

export default function WorkflowStep({ step, isLast = false }) {
  const isStreaming = Boolean(step.stream)
  const [internalExpanded, setInternalExpanded] = useState(step.defaultExpanded === true)
  const expanded = isStreaming ? Boolean(step.stream?.expanded) : internalExpanded

  return (
    <div className={styles.stepRow}>
      <TraceTimeline isLast={isLast} />
      <div className={styles.stepBody}>
        <StepHeader
          durationMs={step.durationMs}
          actionName={step.actionName}
          status={step.status}
          stream={step.stream}
          expanded={expanded}
          interactive={!isStreaming}
          onToggle={() => setInternalExpanded((v) => !v)}
        />
        <ActionCard
          arguments={step.arguments}
          result={step.result}
          stream={step.stream}
          expanded={expanded}
        />
      </div>
    </div>
  )
}
